exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".return-table-header{padding-left:15px;font-weight:700;font-size:12px;text-transform:uppercase}.iframe-table-data-head{text-align:center}.risk-measure-table{padding-right:20px;text-align:end}.fd-report-subtitle{font-size:14px;font-weight:400;color:#878787;margin-left:10px;position:relative}.fd-report-subtitle::before{position:absolute;content:\"-\";top:50;left:-5%;transform:translateX(-50%);margin-right:30px}.fd-progress-bar-container{position:relative;height:12px;min-width:100px;width:40%;transform:rotate(180deg);margin-left:auto}", ""]);

// exports
